import { type ComponentPropsWithRef } from "react";
import { type TitleSize } from "@/constants/content";
import { removeHTMLTags } from "@/utils/removeHTMLTags";

interface TextHeadingProps extends ComponentPropsWithRef<"h1"> {
  type: "plain";
  text: string;
  tag?: TitleSize;
}

interface RichTextHeadingProps extends Omit<TextHeadingProps, "type"> {
  type: "rich";
  allowedTags?: string[];
}

export type HeadingProps = TextHeadingProps | RichTextHeadingProps;

const ALLOWED_TAGS = ["span", "strong", "b", "em", "i", "u", "s", "a", "br"];

export default function Heading(props: HeadingProps) {
  const { type, text, tag = "H2", ...restProps } = props;
  const Tag = tag.toLowerCase() as "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

  if (type === "rich") {
    const { allowedTags = ALLOWED_TAGS, ...restRichProps } =
      restProps as RichTextHeadingProps;

    return (
      <Tag
        {...restRichProps}
        dangerouslySetInnerHTML={{
          __html: removeHTMLTags(text, allowedTags),
        }}
      />
    );
  }

  return <Tag {...restProps}>{text}</Tag>;
}
